import React, { createContext, useState, useEffect, useContext } from 'react';
import {
    onAuthStateChanged,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword, // Import signInWithEmailAndPassword
    signOut // Import signOut
} from 'firebase/auth';
import { auth } from '../services/firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe; // Cleanup subscription on unmount
  }, []);

  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
    // Note: We don't need to manually set currentUser here.
    // The onAuthStateChanged listener will automatically update it
    // when the user is successfully created and signed in.
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
    // As with signup, onAuthStateChanged will handle currentUser state.
  }

  function logout() {
    return signOut(auth).then(() => {
      setCurrentUser(null);
      // Optionally redirect the user after logout
      // history.push('/login');
    });
  }

  const value = {
    currentUser,
    loading, // Expose loading state
    signup,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
